module.exports = __webpack_public_path__ + "static/media/minevideo.450051e3.webm";